import { StateCreator } from "zustand";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";

export interface PlanningApplicationDetailsState {
    [x: string]: RecordDetailsTabNames;
}

export interface PlanningApplicationDetailsSlice {
    planningApplicationDetails: PlanningApplicationDetailsState;
    setPlanningApplicationDetails: (state: PlanningApplicationDetailsState) => void;
    updatePlanningApplicationTab: (recordId: string | number, tab: RecordDetailsTabNames) => void;
}

const initialPlanningApplicationDetailsState: PlanningApplicationDetailsState = {};

export const createPlanningApplicationDetailsSlice: StateCreator<PlanningApplicationDetailsSlice, [], [], PlanningApplicationDetailsSlice> = (set) => ({
    planningApplicationDetails: initialPlanningApplicationDetailsState,
    setPlanningApplicationDetails: (state) => set({ planningApplicationDetails: state }),
    updatePlanningApplicationTab: (recordId, tab) =>
        set((state) => ({ planningApplicationDetails: { ...state.planningApplicationDetails, [recordId]: tab } })),
});

